window.createConfettiParticle = function createConfettiParticle(x, y, index, options = {}) {
    const colors = options.colors || ['#fbbf24', '#a78bfa', '#60a5fa', '#34d399', '#f87171'];
    const particle = document.createElement('div');
    particle.style.position = 'absolute';
    particle.style.width = (options.size || 6) + 'px';
    particle.style.height = (options.size || 6) + 'px';
    particle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
    particle.style.borderRadius = options.shape === 'square' ? '0' : '50%';
    particle.style.pointerEvents = 'none';
    particle.style.left = x + 'px';
    particle.style.top = y + 'px';
    particle.style.transform = 'translate(-50%, -50%)';
    particle.style.opacity = '0';
    particle.style.zIndex = '9999';

    // Movement configuration with separate speed control
    const speed = options.speed || 1; // Speed multiplier (0.5 = slow, 2 = fast)
    const verticalSpread = (options.verticalSpread || 60) * speed;
    const horizontalSpread = (options.horizontalSpread || 80) * speed;
    const gravity = (options.gravity || 20) * speed;

    // Duration is now independent of speed
    const duration = options.duration || 600;
    const durationVariance = options.durationVariance || 400;

    // Calculate random particle trajectory
    const randomAngle = Math.random() * Math.PI * 2; // Random direction
    const randomDistance = Math.random() * 0.5 + 0.5; // 50-100% distance

    // Mid-point position (peak of arc)
    const midX = Math.cos(randomAngle) * horizontalSpread * randomDistance;
    const midY = -Math.abs(Math.sin(randomAngle) * verticalSpread * randomDistance); // Always go up first

    // End position (with gravity)
    const endX = midX * 1.5; // Continue outward
    const endY = gravity + Math.random() * gravity; // Fall down

    // Rotation
    const rotationSpeed = options.rotationSpeed || 1;
    const startRotation = Math.random() * 360;
    const midRotation = startRotation + 360 * rotationSpeed * Math.random();
    const endRotation = midRotation + 360 * rotationSpeed * Math.random();

    // Calculate animation timing
    const particleDuration = duration + Math.random() * durationVariance;
    const delay = index * (options.stagger || 30);

    // Define keyframes with fixed timing for consistent speed
    const movementDuration = 800 / speed; // Base movement takes 800ms at speed 1
    const fadeOutStart = Math.min(0.8, movementDuration / particleDuration); // Start fading at 80% or when movement ends

    const keyframes = [
        {
            transform: `translate(-50%, -50%) scale(0) rotate(${startRotation}deg)`,
            opacity: 0,
        },
        {
            transform: `translate(calc(${midX}% - 50%), calc(${midY}% - 50%)) scale(1) rotate(${midRotation}deg)`,
            opacity: 1,
            offset: Math.min(0.4, (movementDuration * 0.4) / particleDuration),
        },
        {
            transform: `translate(calc(${endX}% - 50%), calc(${endY}% - 50%)) scale(1) rotate(${endRotation}deg)`,
            opacity: 1,
            offset: Math.min(fadeOutStart, movementDuration / particleDuration),
        },
    ];

    // Add fade out phase if duration is longer than movement
    if (particleDuration > movementDuration) {
        keyframes.push({
            transform: `translate(calc(${endX}% - 50%), calc(${endY}% - 50%)) scale(0) rotate(${endRotation}deg)`,
            opacity: 0,
            offset: 1,
        });
    } else {
        // If duration is shorter, fade while moving
        keyframes[keyframes.length - 1].opacity = 0;
        keyframes[keyframes.length - 1].transform =
            `translate(calc(${endX}% - 50%), calc(${endY}% - 50%)) scale(0) rotate(${endRotation}deg)`;
    }

    // Animate the particle
    particle.animate(keyframes, {
        duration: particleDuration,
        delay: delay,
        easing: options.easing || 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        fill: 'forwards',
    });

    // Remove particle after animation completes
    const totalDuration = particleDuration + delay;
    setTimeout(() => particle.remove(), totalDuration + 100);

    return particle;
};

/**
 * Creates a burst of confetti particles
 * @param {HTMLElement} element - The element to attach confetti to
 * @param {Object} options - Configuration options
 * @param {string[]} options.colors - Array of color hex codes
 * @param {number} options.count - Number of particles (default: 8-12)
 * @param {number} options.size - Particle size in pixels (default: 6)
 * @param {string} options.shape - Particle shape: 'circle' or 'square' (default: 'circle')
 * @param {number} options.speed - Speed multiplier: 0.5=slow, 1=normal, 2=fast (default: 1)
 * @param {number} options.verticalSpread - Base vertical distance (% of element height, default: 60)
 * @param {number} options.horizontalSpread - Base horizontal distance (% of element width, default: 80)
 * @param {number} options.gravity - Downward fall distance (% of element height, default: 20)
 * @param {number} options.duration - Animation duration in ms, independent of speed (default: 600)
 * @param {number} options.durationVariance - Random variance added to duration (default: 400)
 * @param {number} options.rotationSpeed - Rotation speed multiplier (default: 1)
 * @param {number} options.stagger - Delay between particles in ms (default: 30)
 * @param {string} options.easing - CSS easing function (default: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)')
 */
window.createConfettiBurst = function createConfettiBurst(element, options = {}) {
    const rect = element.getBoundingClientRect();
    const particleCount = options.count || 8 + Math.floor(Math.random() * 4);
    const particles = [];

    for (let i = 0; i < particleCount; i++) {
        const x = options.x !== undefined ? options.x : Math.random() * rect.width;
        const y = options.y !== undefined ? options.y : rect.height / 2;
        const particle = window.createConfettiParticle(x, y, i, options);
        element.appendChild(particle);
        particles.push(particle);
    }

    return particles;
};
